/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import PropTypes from 'prop-types'

function TimePickerLabel({ id, children }) {
    return <label className="timepicker__label" htmlFor={id}>{children}</label>
}

TimePickerLabel.propTypes = {
    id: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired
}

export default TimePickerLabel;